import React from 'react';
import { Field, reduxForm } from 'redux-form';

import {  AutoCompleteSelect  } from '../../../itrust_common/components/form';
import { connect } from 'react-redux';

let SecureFaxForm = props => {
  const { handleSubmit, label,storeId } = props;
  return (
    <div className="d-flex w-100">
      <Field label={`${label ?? 'Secure Fax'}`}
        name="contact_id"
        displayName="company_name"
        component={AutoCompleteSelect} 
        klass="Contact"
        filter={{ store_id: storeId }}
        textField="company_name" 
        valueField="id" 
        placeholder=""
        className="form-control mx-4" 
        wrapperClasses="d-flex flex-row align-items-center w-100"
        labelClasses="text-nowrap mr-5" />
      <button className="btn btn-primary ml-5" onClick={props.submit}>Send</button>
    </div>
  );
}

SecureFaxForm = reduxForm({
  form: 'secureFaxForm',
  enableReinitialize: true,
})(SecureFaxForm)

const mapStateToProps = (state) => {
  const { exam } = state
  return {
    storeId: exam.exam.store_id,
  }
}



export default connect(mapStateToProps)(SecureFaxForm);
